module.exports = __webpack_public_path__ + "static/media/fort-collins.91e2dcd4.webp";